export const selectProfiles = (state) => state?.profile?.profiles;
export const selectProfileSelected = (state) => state?.profile?.selectProfile;
export const selectProfileAgeRating = (state) => state?.profile?.saveProfileAgeRating;
export const selectProfileName = (state) => state?.profile?.saveProfileName;
